var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wp-items-edit',{attrs:{"content-type":"kb-articles","content-type-singular":"kb-article","content-name":"Knowledge Base Articles","content-name-singular":"Knowledge Base Article"}})}
var staticRenderFns = []

export { render, staticRenderFns }